import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Button from "@/components/button.vue"
  import TrademarkEditor from "@/components/editors/trademark.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {Trademark as TrademarkResolver} from "@/endpoints/rutsolve/gql/resolvers/trademark"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  import router from "@/router"
  import {ref} from "vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'create_trademark',
  setup(__props) {

  const trademarkResolver = new TrademarkResolver()
  const trademark = ref<Trademark>({})

  async function save() {
    await trademarkResolver.create(trademark.value)
    trademarkRedirect()
  }

  function trademarkRedirect() {
    router.push({
      name: "trademarks"
    })
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VerticalNavigator, null, {
    default: _withCtx(() => [
      _createVNode(Breadcrumb, {
        links: [{
        title: 'RutSolve',
        routeName: 'index'
      }, {
        title: 'Trademarks',
        routeName: 'trademarks'
      }],
        title: "Create"
      }),
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, " Create Trademark ", -1)),
      _createVNode(TrademarkEditor, {
        value: trademark.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((trademark).value = $event))
      }, null, 8, ["value"]),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _createVNode(Button, {
        title: "Cancel",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (trademarkRedirect()))
      }),
      _createVNode(Button, {
        title: "Save",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (save()))
      })
    ]),
    _: 1
  }))
}
}

})